<template>
  <VueQrcode :value="QrCodeUrl" tag="img" :width="width"></VueQrcode>
</template>

<script>
import VueQrcode from 'vue-qrcode';
import moment from 'moment';

export default {
  components: {
    VueQrcode
  },
  computed: {
    QrCodeUrl() {
      // return '{"schedule_time_id":"' + this.scheduleTimeId + '"}';
      return `{"schedule_time_id":"${this.scheduleTimeId}", "date": "${this.date}"}`;
    }
  },
  props: {
    width: {
      type: Number,
      default() {
        return 500;
      }
    },
    scheduleTimeId: {
      required: true,
      type: [String, Number]
    },
    date: {
      type: String,
      default() {
        return moment().format('YYYY-MM-DD');
      }
    }
  },
  data() {
    return {
      webUrl: process.env.VUE_APP_API_URL
    };
  }
};
</script>
